export default __webpack_public_path__ + "static/EzyMedical BM - Homepage Banner (EDP)-c5e42984b141950853ea15dacde46c9e.png";